import { TEDCustomDateTimeParser } from './TEDCustomDateTimeParser';

import { TEDParseDateTimeMode } from '../FormatterTypes';

export class TEDParseIntAsYear extends TEDCustomDateTimeParser {
  public static getInstance(): TEDParseIntAsYear {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDParseIntAsYear;

  public mode() {
    return TEDParseDateTimeMode.pdmY;
  }
}
